import { BaseService } from './base.service';
import * as i0 from "@angular/core";
import * as i1 from "./feathers.service";
export class ConfigService extends BaseService {
    constructor(feathers) {
        super('config', feathers.app);
    }
}
ConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(i0.ɵɵinject(i1.FeathersService)); }, token: ConfigService, providedIn: "root" });
